import { createContext, useState, Dispatch, SetStateAction } from 'react';

interface Context {
  setFolderName: Dispatch<SetStateAction<string>>;
  folderName: string;
}

export const OmnisearchContext = createContext<Context>({
  setFolderName: () => {
    return;
  },
  folderName: '',
});

interface Props {
  children: React.ReactNode;
}

export const OmnisearchContextProvider = ({ children }: Props) => {
  const [folderName, setFolderName] = useState('');

  return (
    <OmnisearchContext.Provider value={{ folderName, setFolderName }}>
      {children}
    </OmnisearchContext.Provider>
  );
};
